import * as Yup from 'yup';
import { PlannerFormModel } from './PlannerFormModel';

const {
  formField: { cargo, turnos, cantidad, repeticion },
} = PlannerFormModel;

export const validationSchema = Yup.object().shape({
  [cargo.name]: Yup.object().nullable().required(cargo.requiredErrorMsg),
  [turnos.name]: Yup.array().min(1, turnos.requiredErrorMsg).required(turnos.requiredErrorMsg),
  [cantidad.name]: Yup.number().min(1, 'Debe ser al menos 1').required(cantidad.requiredErrorMsg),
  [repeticion.name]: Yup.string().required(repeticion.requiredErrorMsg),
});
